(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/swish-cellphone/assets/swish-cellphone.js') >= 0) return;  svs.modules.push('/components/accountservices-react/swish-cellphone/assets/swish-cellphone.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const MobileInput = svs.ui.reactFormInputs.MobileInput;
const Button = svs.ui.ReactButton;

const SwishCellphone = _ref => {
  let setNewCellphone = _ref.setNewCellphone,
    _ref$newCellphone = _ref.newCellphone,
    newCellphone = _ref$newCellphone === void 0 ? '' : _ref$newCellphone,
    cellphone = _ref.cellphone,
    isDeposit = _ref.isDeposit;
  const _React$useState = React.useState(!cellphone),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isShowInput = _React$useState2[0],
    setIsShowInput = _React$useState2[1];
  const handleChange = e => {
    let formattedNumber = e.target.value;
    if (formattedNumber.length > 2 && formattedNumber.slice(0, 2) === '46') {
      formattedNumber = "0".concat(formattedNumber.slice(2));
    }
    if (formattedNumber.length > 3 && formattedNumber.slice(0, 3) === '+46') {
      formattedNumber = "0".concat(formattedNumber.slice(3));
    }
    if (formattedNumber.length > 4 && formattedNumber.slice(0, 4) === '0046') {
      formattedNumber = "0".concat(formattedNumber.slice(4));
    }
    setNewCellphone(formattedNumber);
  };
  React.useEffect(() => {
    if ((cellphone === null || cellphone === void 0 ? void 0 : cellphone.length) > 3) {
      setIsShowInput(false);
    }
  }, [cellphone]);
  return React.createElement("div", null, !isShowInput && React.createElement("div", {
    className: "u-flex u-flex-align-items-end margin-top-2 margin-bottom"
  }, React.createElement("div", {
    className: "u-flex-grow-1"
  }, "Mobilnummer:", ' ', React.createElement("span", {
    className: "f-bold"
  }, cellphone)), React.createElement("div", null, React.createElement(Button, {
    "aria-label": "\xC4ndra telefonnummer f\xF6r Swish",
    onClick: () => setIsShowInput(true),
    size: 100,
    transparent: true
  }, "\xC4ndra"))), isShowInput && React.createElement("div", {
    className: "padding-top"
  }, React.createElement(MobileInput, {
    id: "newMobilePhoneNumber",
    infoMessage: "Nytt mobilnummer sparas med ".concat(isDeposit ? 'insättning' : 'uttag'),
    inputHelpText: "Mobilnummer",
    inputMode: "tel",
    isLessSpace: true,
    isRequired: true,
    label: "Ange nytt mobilnummer",
    name: "newmobile",
    onChange: handleChange,
    type: "text",
    value: newCellphone || ''
  })));
};
svs.accountservicesReact.swishCellphone.SwishCellphone = SwishCellphone;

 })(window);